import type { Stream } from "@zoom/videosdk";
import { LocalAudioDelegator } from "../../../../core/room/participant/media/MediaDelegator";

export class ZoomLocalAudioDelegator implements LocalAudioDelegator {
  readonly kind = "audio" as const;
  #stream: typeof Stream;

  constructor(stream: typeof Stream) {
    this.#stream = stream;
  }

  get deviceId() {
    return this.#stream.getActiveMicrophone();
  }

  get isEnabled() {
    return !!this.#stream;
  }
}
